import Valg from '../../../Shared/Scripts/Models/Valg';

export interface ValgState {
    aStotte?: Valg<string>;
    bSemester?: Valg<string>;
    bxSemester?: Valg<string>;
    cSp?: number;
    cxSp?: number;
    dBosted?: Valg<string>;
    eSkolepenger?: Valg<string>;
    fSpBelop?: number;
    visUtbetalingsplan: boolean;
    visVilkar: boolean;
    visFordeling: boolean;
}

export const UPDATE_VALG = 'UPDATE_VALG';
export const TOGGLE_UTBETALINGSPLAN = 'TOGGLE_UTBETALINGSPLAN';
export const TOGGLE_VILKAR = 'TOGGLE_VILKAR';
export const TOGGLE_FORDELING = 'TOGGLE_FORDELING';

export interface UpdateValgAction {
    type: typeof UPDATE_VALG;
    payload: Partial<ValgState>;
}

export interface ToogleUtbetalingsplanAction {
    type: typeof TOGGLE_UTBETALINGSPLAN;
}

export interface ToogleVilkarAction {
    type: typeof TOGGLE_VILKAR;
}

export interface ToogleFordelingAction {
    type: typeof TOGGLE_FORDELING;
}

export type ValgStateActionTypes =
    | UpdateValgAction
    | ToogleVilkarAction
    | ToogleFordelingAction
    | ToogleUtbetalingsplanAction;
